export const Props = (props = {}) => ({
    type: props.type
});
export const validate = () => true;
export const fix = (props, styles) => props;
export const label = 'Collection';
export const type = 'collection';
export const category = 'basic';
export const forms = [];
//# sourceMappingURL=collection.js.map